module.exports = __webpack_public_path__ + "img/party-horn.ecb81197.svg";